var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-strap"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.show)?_c('h1',[_vm._v("Joe Wood")]):_vm._e()]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.job))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fc0320c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NameStrap.vue
// module id = 53
// module chunks = 0